/**
 * auth/ProtectedRoute.jsx — Redirects unauthenticated users to /login.
 */

import { Navigate } from 'react-router-dom'
import { useAuth } from './AuthContext'

export default function ProtectedRoute({ children, requiredRole }) {
  const { user, loading, authError, effectiveRole } = useAuth()

  if (loading) return <div>Loading…</div>

  if (authError) return <Navigate to="/login" replace state={{ authError: true }} />

  if (!user) return <Navigate to="/login" replace />

  if (requiredRole && effectiveRole !== requiredRole) {
    return <Navigate to="/" replace />
  }

  return children
}
